import { create } from 'zustand';

interface OnboardingUnsavedChangesState {
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
  reset: () => void;
}

export const useOnboardingUnsavedChangesStore = create<OnboardingUnsavedChangesState>(set => ({
  isDirty: false,
  setIsDirty: isDirty => set({ isDirty }),
  reset: () => set({ isDirty: false }),
}));
